export const CARD_STYLE_EXPERIMENT = 'BF-16825-Card-Style-Quiz';
export const CARD_STYLE_SUPPRESSED_VARIANTS = ['v1', 'v2'];

export const QUESTION_TYPE_SCALE = 'scale';
export const QUESTION_TYPE_TAP_ON_IMAGE = 'tap_on_image';
const TAG_YOURSELF_WORKFLOW_TAG = 'tag_yourself_quiz_experiment';
const SHOPPING_QUIZ_RESULTS_TAG = 'shopping_quiz_results';

const getWorkflowTags = buzz => buzz?.laser_tags?.bf_content_description?.workflow || [];

const getFramesAndFormatsTags = buzz =>
  buzz?.laser_tags?.bf_content_description?.frames_and_formats || [];

export const getBfpQuizSubbuzzes = buzz =>
  (buzz?.sub_buzzes || []).filter(subbuzz => subbuzz.form === 'bfp');

export const getBfpQuizQuestions = buzz =>
  getBfpQuizSubbuzzes(buzz).flatMap(subbuzz => subbuzz?.bfp_data?.data?.questions || []);

export const isCardStyleSuppressedVariant = variant =>
  CARD_STYLE_SUPPRESSED_VARIANTS.includes(variant);

export const isCardStyleExperimentVariant = variant =>
  isCardStyleSuppressedVariant(variant);

export const isTagYourselfExperiment = buzz =>
  getWorkflowTags(buzz).some(tag => tag.tag_name === TAG_YOURSELF_WORKFLOW_TAG);

export const shouldRenderShoppingCarousel = buzz =>
  getFramesAndFormatsTags(buzz).some(tag => tag.tag_name === SHOPPING_QUIZ_RESULTS_TAG);

export const isCardStyleExperimentEligible = buzz => {
  if ((!buzz?.isTrivia && !buzz?.isPersonality) || buzz?.isTimedTrivia) {
    return false;
  }

  if (!buzz?.isUS) {
    return false;
  }

  if ((buzz?.bfpFormats || []).some(format => format === 'scale_quiz' || format === 'tap_on_image')) {
    return false;
  }

  const questions = getBfpQuizQuestions(buzz);
  if (questions.some(question =>
    question?.type === QUESTION_TYPE_SCALE ||
    question?.type === QUESTION_TYPE_TAP_ON_IMAGE ||
    question?.multiselect
  )) {
    return false;
  }

  if (getBfpQuizSubbuzzes(buzz).some(subbuzz => subbuzz?.bfp_data?.data?.question_flow_control)) {
    return false;
  }

  if (isTagYourselfExperiment(buzz)) {
    return false;
  }

  if (shouldRenderShoppingCarousel(buzz)) {
    return false;
  }

  return true;
};